__turbopack_context__.v({
  "appliedFiltersWrap": "catalog-brands-module-scss-module__RgZJ2W__appliedFiltersWrap",
  "catalogSeoLinks__collections": "catalog-brands-module-scss-module__RgZJ2W__catalogSeoLinks__collections",
  "categoriesGrid": "catalog-brands-module-scss-module__RgZJ2W__categoriesGrid",
  "main": "catalog-brands-module-scss-module__RgZJ2W__main",
  "root": "catalog-brands-module-scss-module__RgZJ2W__root",
  "selectorWrap": "catalog-brands-module-scss-module__RgZJ2W__selectorWrap",
  "seoLinks": "catalog-brands-module-scss-module__RgZJ2W__seoLinks",
});
